import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useEffect, useRef, useState } from "react";
import tw from "tailwind-styled-components";
import useIsMounted from "./hooks/useIsMounted";
import FormError from "./FormError";
import { nanoid } from "nanoid";
const Container = tw.div`
  relative
  w-full
`;
const BasicInputStyles = `
  appearance-none
  shadow-none
  rounded-md
  border
  border-white
  border-opacity-10
  outline-0
  focus:outline-0
  focus:border-solid
  focus:border-white
  focus:ring-0
  focus:border-opacity-25
  py-2
  px-3
  w-full
  text-white
`;
const BorderlessInputStyles = `
  appearance-none
  shadow-none
  focus:outline-0
  focus:border-solid
  focus:border-opacity-25
  bg-transparent
  py-2
  w-full
  text-white
  cursor-pointer
`;
const DisabledInputStyles = `
  text-grayscale-lightest
  cursor-not-allowed
`;
const BasicInput = /*#__PURE__*/ forwardRef(({ disabled, error = null, ariaLabel = null, required = false, includeErrorPadding = false, noMargin = false, placeholder, readOnly = false, value, fontSize = "md", height = "", padding = "", onChange, background = "bg-grayscale-medium", onKeyDown, onFocus, onBlur, style = {}, type, autoFocus = false, containerStyle = {}, className = "" }, passedRef)=>{
    const thisRef = useRef(null);
    const ref = passedRef || thisRef;
    const isMounted = useIsMounted();
    const [hasCalledAutoFocus, setHasCalledAutoFocus] = useState(false);
    useEffect(()=>{
        if (isMounted() && autoFocus && !hasCalledAutoFocus && typeof ref !== "function" && ref.current) {
            setHasCalledAutoFocus(true);
            ref?.current?.focus();
        }
    }, [
        isMounted,
        autoFocus,
        hasCalledAutoFocus,
        setHasCalledAutoFocus,
        ref
    ]);
    return /*#__PURE__*/ _jsxs(Container, {
        style: containerStyle,
        children: [
            /*#__PURE__*/ _jsx("input", {
                ...ariaLabel ? {
                    "aria-label": ariaLabel
                } : {},
                ref: ref,
                /* This is a hack to get around the fact that we designed this to take padding & also set padding... */ className: `${BasicInputStyles.split("\n").filter((x)=>!(x.match(/py-2/) && padding)).join("\n")} text-${fontSize == "xs" ? "[11px]" : fontSize} ${!noMargin && "mb-3"} ${padding} ${height} ${background} ${includeErrorPadding && "pr-9"} ${disabled && DisabledInputStyles} ${className}`,
                disabled: disabled,
                required: required,
                placeholder: placeholder,
                value: value,
                readOnly: readOnly,
                type: type,
                onChange: onChange,
                onKeyDown: (e)=>{
                    if (e.key === "Enter") {
                        e.preventDefault();
                    }
                    onKeyDown && onKeyDown(e);
                },
                onFocus: onFocus,
                onBlur: onBlur,
                autoComplete: "new-password",
                id: `input-${nanoid()}`,
                style: style
            }),
            error && /*#__PURE__*/ _jsx(FormError, {
                hasLabel: false,
                normalizedError: error
            })
        ]
    });
});
BasicInput.displayName = "BasicInput";
export { BasicInput };
